import React from 'react';
import { Grid } from '@mui/material';
import { SectionDivider } from '../../CommonComponents';
import TenantLocation from '../TenantLocation';

interface VisitingAddressProps {
    entity: any;
    onChange: (e: any) => void;
}

const VisitingAddressBlock = ({ entity, onChange }: VisitingAddressProps) => (
    <Grid item md={12} lg={6}>
        <SectionDivider label="Besöksadress" marginTop={2} marginBottom={0} />
        <TenantLocation
            entity={entity}
            onChange={onChange}
        />
    </Grid>
);

export default React.memo(VisitingAddressBlock);
